<app-page-header title="Incoming transport locations">
    <div class="btn-group">
        <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
        <app-change-log-link *bizPermissionRequired="'Transport_Action_IncomingLocation_ShowLog'" [title]="'Ingoing transport locations log'">
            <app-change-log-link-entity type="TransportInConfiguration"></app-change-log-link-entity>
        </app-change-log-link>
    </div>
</app-page-header>

<div class="btn-toolbar">
    <div class="btn-group">
        <button type="button" class="btn btn-primary btn-sm"
                *bizPermissionRequired="'Transport_View_IncomingLocations_Details'"
                [disabled]="selectedLocations.length < 1" (click)="onDetailsClicked($event)">
            Show locations
        </button>
    </div>
    <div class="btn-group">
        <button type="button" class="btn btn-primary btn-sm"
                *bizPermissionRequired="'Transport_View_IncomingLocations_Details'"
                [disabled]="selectedLocations.length !== 1" (click)="onLogClicked($event)">
            Show log
        </button>
    </div>
    <div class="btn-group">
        <button type="button" class="btn btn-primary btn-sm" *bizPermissionRequired="'Transport_Action_IncomingLocation_Export'"
                [disabled]="!canExportLocations" (click)="exportLocations(selectedLocations)">
            Export
        </button>
    </div>
    @if (hasblockedLocations) {
    <div class="btn-group">
        <button type="button" class="btn btn-primary btn-sm" *bizPermissionRequired="'Transport_Action_IncomingLocation_Unblock'"
                [disabled]="!canUnblockLocations" (click)="unblockLocations(selectedLocations)">
            Unblock
        </button>
    </div>
    }
    <div class="btn-group">
        <button type="button" class="btn btn-primary btn-sm"
                *bizPermissionRequired="'Transport_Action_IncomingLocation_Edit'"
                [disabled]="selectedLocations.length < 1" (click)="onEnableLocations($event)">
            Enable selected locations
        </button>
    </div>
    <div class="btn-group">
        <button type="button" class="btn btn-primary btn-sm"
                *bizPermissionRequired="'Transport_Action_IncomingLocation_Edit'"
                [disabled]="selectedLocations.length < 1" (click)="onDisableLocations($event)">
            Disable selected locations
        </button>
    </div>
</div>

<dx-data-grid biz-grid
              [dataSource]='locations'
              [selection]='{ mode: "multiple" }'
              [bizSetPager]="false"
              (onToolbarPreparing)="onToolbarPreparing($event)"
              (onContextMenuPreparing)="onContextMenuPreparing($event)"
              (onSelectionChanged)="onSelectionChanged($event)"
              (onEditingStart)="onEditingStart($event)"
              (onRowRemoving)="onRowRemoving($event)"
              (onRowDblClick)="onRowDblClick($event)">

    <dxo-editing mode="row"
                 [allowAdding]="allowAdding"
                 [allowUpdating]="allowDetails"
                 [allowDeleting]="allowDeleting">
        <dxo-texts editRow="Details"></dxo-texts>
    </dxo-editing>
    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
    @if (showBlockedColumn) {
    <dxi-column dataField="BlockedByImport" caption="Blocked" dataType="boolean" allowFiltering="true"></dxi-column>
    }
    <dxi-column dataField="Enabled" caption="Enabled" dataType="boolean" width="8em"></dxi-column>
    <dxi-column dataField="Name" caption="Name" dataType="string" sortOrder="asc"></dxi-column>
    <dxi-column dataField="TransportTypeName" caption="Transport type" dataType="string"></dxi-column>
    <dxi-column dataField="DisplayAddress" caption="Address" dataType="string"></dxi-column>
    <dxi-column dataField="FrequencyInSeconds" caption="Frequency (sec.)" dataType="number"></dxi-column>
    <dxi-column dataField="PreDisassembleStepName" caption="Pre disassemble" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="CustomDisassembleStepName" caption="Custom disassemble" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="PostDisassembleStepName" caption="Post disassemble" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="MonitorStatus" caption="Monitor status" cellTemplate="statusTemplate" alignment="center">
        <div *dxTemplate="let data of 'statusTemplate'">
            <app-status-traffic-light [status]="data.value"></app-status-traffic-light>
        </div>
    </dxi-column>
    <dxi-column dataField="DocumentTypeName" caption="Document Type" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="FormatName" caption="Format" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="VariantName" caption="Variant" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="VariantVersionName" caption="Version" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="FormatTypeName" caption="Format type" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="SenderIdMacro" caption="Sender id macro" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="SenderIdQualifierMacro" caption="Sender id qualifier macro" dataType="string" [visible]="false"></dxi-column>

    <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(locations, 'CreatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
    <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(locations, 'UpdatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

    <dxi-column type="buttons" [fixed]="true" fixedPosition="right">
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
        <dxi-button template="copyTransportConfigTemplate" [visible]="allowAdding"></dxi-button>
        <dxi-button name="Show Log" template="logTemplate" [visible]="allowShowLog"></dxi-button>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'copyTransportConfigTemplate'">
        <a (click)="onDuplicateLocation(cell.data)" class="dx-link">Copy</a>
    </ng-container>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
        <app-change-log-link *bizPermissionRequired="'Transport_Action_IncomingLocation_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="TransportInConfiguration" [id]="cell.data.Id"></app-change-log-link-entity>
        </app-change-log-link>
    </ng-container>
</dx-data-grid>
